<template src="./Plan.html"></template>
<script>
import moment from "moment";
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      plan: {},
      status: null,
      active: null,
      name: null,
      description: null,
      initialDate: null,
      finalDate: null,
      billingDay : null,
      effectiveDay : null,
      daysBeforeBilling: null,
      planValue: null,
      code: null,
      planIdIugu: null,
      companyId: null,
      isCombo: false,
      period: null,
      method: null,
      planTypeId: null,
      planType: null,
      rootCampaign: null,
      initialDateFormated: null,
      finalDateFormated: null,
      billingDays : [],
      effectiveDays : [],
      plansType: [],
      showlistPlans: true,
      companies: [],
      plans: [],
      periods: [
        { value: "mensais", text: "Mensal" },
        { value: "semestrais", text: "Semestral" },
        { value: "anuais", text: "Anual" },
      ],
      methods: [
        { value: "boleto", text: "Boleto bancário" },
        { value: "cartao", text: "Cartão de crédito" },
        { value: "todos", text: "Todos (Boleto e Cartão de crédito)" },
      ],
      invalidFields: {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        billingDay: false,
        effectiveDay: false,
        daysBeforeBilling: false,
        planValue: false,
        code: false,
        planTypeId: false,
        planIdIugu: false,
        period: false,
        method: false,
        planPackageId: false,
      },
      saveClicked: false,
      planPackages: [],
      planPackageId: null,
      additionalLifeValue: null,
      currentx: 1,
      pagination: false,
      numPages: 0,
      windowWidth: 0,
      search: ""
    };
  },
  watch: {
    name: function (newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    description: function (newVal) {
      const vm = this;
      vm.invalidFields.description = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    initialDateFormated: function () {
      const vm = this;
      if(vm.saveClicked) vm.validateDates();
    },
    finalDateFormated: function () {
      const vm = this;
      if(vm.saveClicked) vm.validateDates();
    },
    billingDay: function (newVal) {
      const vm = this;
      vm.invalidFields.billingDay = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    effectiveDay : function (newVal){
      const vm = this;
      vm.invalidFields.effectiveDay = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    daysBeforeBilling : function (newVal){
      const vm = this;
      vm.invalidFields.daysBeforeBilling = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    code: function (newVal) {
      const vm = this;
      vm.invalidFields.code = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planValue: function (newVal) {
      let vm = this;
      vm.invalidFields.planValue = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    period: function (newVal) {
      const vm = this;
      vm.invalidFields.period = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    method: function (newVal) {
      const vm = this;
      vm.invalidFields.method = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planPackageId: function (newVal) {
      let vm = this;
      vm.invalidFields.planPackageId = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planType: function(newVal) {
      const vm = this;
      vm.invalidFields.planTypeId = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
      vm.planTypeId = vm.invalidFields.planTypeId ? null : newVal.id;
      vm.isMultiple = vm.planTypeId === 3? true: vm.isMultiple;
    },
    planIdIugu: function (newVal) {
      const vm = this;
      vm.invalidFields.planIdIugu = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    currentx: function() {
      this.getPlans()
    }
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    window.addEventListener("resize", this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    init() {
      const vm = this;
      vm.getPlans();
      vm.getTypePlans();
      this.getAllCompanies();
      vm.businessType="B2B";
      vm.getPlanPackages();
      vm.fillBillingOptions();
      vm.fillEffectiveDayOptions();
    },
    removePlan(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "customerplan/" + id, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlans();
          }
        });
    },
    goToPlanList() {
      const vm = this;
      vm.checkFalseInvalidFields();
      vm.showlistPlans = true;
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/companies?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
          }
        });
    },
    getAllCompanies() {
      this.axios
        .get(
          this.$store.state.filooServer +
            "company/all-companies",
          {
            headers: { Authorization: this.$session.get("bearerDefault") },
          }
        )
        .then(response =>{
          if (response.status == 200) {
            this.companies = response.data;
          }
        });
    },
    getTypePlans() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan/all-types",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
        .then(function (response) {
          if (response.status === 200) {
            vm.plansType = response.data;
          }
        });
    },
    changeStatus(id, namePlan) {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "customerplan/change_status/" + id,
          {},
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Operação realizada!",
              "O status do plano <b style='color: #FF9F43; font-weight: 500'>" +
                namePlan +
                "</b> foi alterado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        });
    },
    seePlan(tr) {
      const vm = this;
      vm.checkFalseInvalidFields();
      vm.getPlan(tr.id);
    },
    addNewPlan() {
      const vm = this;
      vm.checkFalseInvalidFields();
      vm.planPackageId = null,
      vm.additionalLifeValue = null,
      vm.plan = {};
      vm.isMultiple = false;
      vm.status = null;
      vm.active = null;
      vm.name = null;
      vm.description = null;
      vm.initialDate = null;
      vm.finalDate = null;
      vm.billingDay = null;
      vm.effectiveDay = null;
      vm.daysBeforeBilling = 10;
      vm.planValue = null;
      vm.code = null;
      vm.planIdIugu = null;
      vm.companyId = vm.$route.params.id;
      vm.isCombo = false;
      vm.period = null;
      vm.method = null;
      vm.planTypeId = null;
      vm.discount = null;
      vm.options = null;
      vm.rootCampaign = null;
      vm.singleInstallment = 0;
      vm.licensingTax = 0;
      vm.nursingTax = 0;
      vm.initialDateFormated = null;
      vm.finalDateFormated = null;
      vm.checkFalseInvalidFields();
      vm.showlistPlans = false;
      vm.period = null,
      vm.planType = null,
      vm.method = null
    },
    checkFalseInvalidFields() {
      const vm = this;
      vm.saveClicked = false;
      vm.invalidFields = {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        billingDay: false,
        effectiveDay: false,
        daysBeforeBilling: false,
        planValue: false,
        code: false,
        planTypeId: false,
        planIdIugu: false,
        period: false,
        method: false,
        isCombo: false,
        planPackageId: false,
      };
    },
    getPlans() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer +
          `company/customerplan/${vm.$route.params.id}?page=${this.currentx - 1}&size=10&search=${vm.search}`,
        {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.plans = response.data.content;
            vm.showlistPlans = true;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível listar os planos, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    dateFormatted(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    validateFields() {
      const vm = this;
      let invalid = false;
      const error = vm.invalidFields;
      vm.saveClicked = true;

      error.businessType = vm.testNullUndefinedEmpty(vm.businessType);
      error.name = vm.testNullUndefinedEmpty(vm.name);
      error.description = vm.testNullUndefinedEmpty(vm.description);
      vm.validateDates();
      error.billingDay = vm.testNullUndefinedEmpty(vm.billingDay);
      error.planValue = vm.planValue !== 0 && vm.testNullUndefinedEmpty(vm.planValue);
      error.code = vm.testNullUndefinedEmpty(vm.code)
      error.planTypeId = vm.testNullUndefinedEmpty(vm.planType);
      error.period = vm.testNullUndefinedEmpty(vm.period);
      error.method = vm.testNullUndefinedEmpty(vm.method);
      error.planPackageId = vm.testNullUndefinedEmpty(vm.planPackageId);

      invalid = error.businessType || error.name || error.description || error.initialDate
        || error.finalDate || error.planValue || error.code || error.planTypeId || error.period
        || error.method || error.planPackageId;

      if (invalid) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos!",
          color: "warning",
          icon: "error_outline",
          position: "top-right",
        });
      } else {
        vm.testNullUndefinedEmpty(vm.plan.id) ?
          vm.saveNewPlan()
          :vm.updatePlan();
      }
    },
    saveNewPlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      let plan = {
        status: true,
        active: vm.active,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        billingDay : vm.billingDay != null ?  vm.billingDay.value : null,
        effectiveDay: vm.billingDay != null ? (vm.effectiveDay === null ? vm.billingDay.value : vm.effectiveDay.value) : null,
        daysBeforeBilling: vm.billingDay != null ? (vm.daysBeforeBilling === null ? 10 : vm.daysBeforeBilling) : null,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId: vm.$route.params.id,
        isCombo: vm.isCombo,
        period: vm.period.value,
        method: vm.method.value,
        planTypeId: vm.planTypeId,
        businessType: 'B2B',
        rootCampaign: vm.rootCampaign,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage: vm.planPackageId,
        additionalLifeValue: parseFloat(vm.additionalLifeValue.toString().replace(",", ".")),
      };
      vm.axios
        .post(vm.$store.state.filooServer + "customerplan/", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Operação realizada!",
              "O plano <b style='color: #FF9F43; font-weight: 500'>" +
                plan.name +
                "</b> foi criado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function () {
          vm.$swal(
            "Atenção!",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
            "error"
          );
        }).finally(() => {vm.showlistPlans = true});
    },
    updatePlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      let plan = {
        id: vm.plan.id,
        status: vm.plan.status,
        active: vm.plan.active,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        billingDay : vm.billingDay != null ? vm.billingDay.value : null,
        effectiveDay: vm.effectiveDay == null || vm.effectiveDay.value == "" ? vm.billingDay.value : vm.effectiveDay.value,
        daysBeforeBilling: vm.billingDay != null ? (vm.daysBeforeBilling !=  null ? vm.daysBeforeBilling : 10) : null,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId: vm.companyId,
        isCombo: vm.isCombo,
        period: vm.period.value,
        method: vm.method.value,
        planTypeId: vm.planTypeId,
        businessType: 'B2B',
        rootCampaign: vm.rootCampaign,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage: vm.planPackageId,
        additionalLifeValue: parseFloat(vm.additionalLifeValue.toString().replace(",", ".")),
      };
      vm.axios
        .put(vm.$store.state.filooServer + "customerplan", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Operação realizada!",
              "Os dados do plano <b style='color: #FF9F43; font-weight: 500'>" +
                vm.plan.name +
                "</b> foram alterados com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function () {
          vm.$swal(
            "Atenção!",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
            "error"
          );
        })
        .finally(() => {vm.showlistPlans = true});
    },
    getPlan(idPlan) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "customerplan/find_by_id/" + idPlan,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.plan = response.data;
            vm.fillPlan();
          }
        })
        .catch(function () {
          vm.showlistPlans = true;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível localizar o plano selecionado, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    getPlanPackages() {
      const vm = this;
      vm.axios.get(`${vm.$store.state.filooServer}plan-package`,
        { headers: { Authorization: vm.$session.get("bearerDefault") }, } )
        .then( res => {
          if (res.status === 200) {
            vm.planPackages = res.data;
          }
        })
        .catch( err => {
          console.log({
            endpointURL: "plan-package",
            error_getPlanPackages: err,
          });
          vm.showNotifyWarning(
            "Ocorreu um erro ao buscar a lista de pacote de planos. Por favor, tente novamente mais tarde!",
            5000,
          )
        })
    },
    fillBillingOptions(){
      const vm = this;
      for (let i = 1; i <= 30; i++) {
        vm.billingDays.push({value : i, text : i.toString()});
      }
    },
    fillEffectiveDayOptions(){
      const vm = this;
      for (let i = 1; i <= 30; i++) {
        vm.effectiveDays.push({value : i, text : i.toString()});
      }
    },
    fillPlan() {
      const vm = this;
      vm.clearFields();
      vm.initialDateFormated = "";
      vm.finalDateFormated = "";
      if (vm.testNullUndefinedEmpty(vm.plan.initialDate) === false) {
        vm.initialDateFormated = moment(String(vm.plan.initialDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (vm.testNullUndefinedEmpty(vm.plan.finalDate) === false) {
        vm.finalDateFormated = moment(String(vm.plan.finalDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (
        vm.testNullUndefinedEmpty(vm.plan.planValue) === false &&
        vm.plan.planValue != 0
      ) {
        let floatValue = parseFloat(vm.plan.planValue);
        let fixedValue = floatValue.toFixed(2);
        vm.planValue = fixedValue.toString().replace(".", ",");
      } else if (vm.plan.planValue == 0) {
        vm.planValue = vm.plan.planValue.toFixed(2);
      }
      vm.name = vm.plan.name;
      vm.active = vm.plan.active;
      vm.description = vm.plan.description;
      vm.code = vm.plan.code;
      vm.billingDay = vm.billingDays.find(b => {return b.value == vm.plan.billingDay;});
      vm.effectiveDay = vm.effectiveDays.find(e =>{return e.value == vm.plan.effectiveDay;});
      vm.daysBeforeBilling = vm.plan.daysBeforeBilling;
      vm.companyId = vm.$route.params.id;
      vm.period =  vm.periods.find(p => {
              return p.value === vm.plan.period;});
      vm.method = vm.methods.find(p => {
              return p.value === vm.plan.method;});
      vm.planType = vm.plansType.find(p => {
              return p.id === vm.plan.planTypeId;});
      vm.rootCampaign = vm.plan.rootCampaign,
      vm.isCombo = vm.plan.isCombo;
      vm.showlistPlans = false;
      vm.planIdIugu = vm.plan.planId;
      vm.planPackageId = vm.plan.planPackageId;
      vm.additionalLifeValue = vm.plan.additionalLifeValue.toFixed(2);
    },
    dateFormattedUs(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },

    validateDates() {
      const vm = this;
      const isValid = vm.dateIsBeforeAnotherDate(vm.initialDateFormated, vm.finalDateFormated);

      vm.invalidFields.initialDate = !isValid || vm.testNullUndefinedEmpty(vm.initialDateFormated);
      vm.invalidFields.finalDate = !isValid || vm.testNullUndefinedEmpty(vm.finalDateFormated);
    },

    clearFields() {
      const vm = this;
      vm.name = null;
      vm.description = null;
      vm.daysBeforeBilling = null;
      vm.billingDay = [];
      vm.effectiveDay = [];
      vm.code = null;
      vm.companyId = null;
      vm.options = null;
      vm.period =  [];
      vm.method = [];
      vm.planType = [];
      vm.rootCampaign = null,
      vm.isCombo = false;
      vm.planIdIugu = null;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleSearch(search) {
      this.search = search
      this.currentx === 1 ? this.getPlans() : this.currentx = 1
    },
  },
};
</script>

<style lang="scss" src="./Plan.scss">
</style>
